import { StoreModel } from "../../models/Index";

export default function ping(Store: StoreModel, event: any) {
    return "pong";
}
